import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { AuthService, User } from './../user/auth.service';
import { Component, OnInit, isDevMode } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Registry } from '../registry/registry';
import { AnalyticsService } from '../analytics/analytics.service';
import { Gift } from '../gift/gift';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Website } from '../website-builder/wedding';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';
declare var Stripe;
@Component({
  selector: 'app-hitchd-payment-page',
  templateUrl: './hitchd-payment-page.component.html',
  styleUrls: ['./hitchd-payment-page.component.scss']
})

export class HitchdPaymentPageComponent implements OnInit {

  price = 0;
  currency: string;
  symbol: string;
  uuid: string;
  country: string;
  stripe = false;
  smallPrice = 0;
  registry: Registry;
  canUpgrade = false;
  type = null;
  expired = false;
  daysLeft = 0;
  tier: string;
  isEu: boolean;
  currentPrice: any;
  paidAmount: number=0;
  mode: string;
  hasLoops: boolean;
  pricingText: string;
  
  gifts: Gift[];
  user: User;
  displayToggles: {
    registry: {
      plus: boolean;
      unlimited: boolean
    }
    website: boolean,
    bundle: boolean,
    current: "registry" | "website" | "bundle" | ""
  }
  euCountries = [
    'AL',
    'AD',
    'AM',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FO',
    'FI',
    'FR',
    'GB',
    'GE',
    'GI',
    'GR',
    'HU',
    'HR',
    'IE',
    'IS',
    'IT',
    'LT',
    'LU',
    'LV',
    'MC',
    'MK',
    'MT',
    'NO',
    'NL',
    'PO',
    'PT',
    'RO',
    'RU',
    'SE',
    'SI',
    'SK',
    'TR',
    'UA',
    'VA'
  ];
  pricing: any =
    {
      AU: { country: "AU", website: 249, mid: 179, unlimited: 197, bundle: 399, micro: 149, },
      DE: { country: "DE", website: 199, mid: 149, unlimited: 147, bundle: 349, micro: 119, },
      NZ: { country: "NZ", website: 249, mid: 179, unlimited: 197, bundle: 349, micro: 149, },
      GB: { country: "GB", website: 199, mid: 149, unlimited: 147, bundle: 349, micro: 119, },
      CA: { country: "CA", website: 199, mid: 149, unlimited: 147, bundle: 349, micro: 119, },
      US: { country: "US", website: 199, mid: 149, unlimited: 147, bundle: 349, micro: 119, },
      DK: { country: "DK", website: 1199, mid: 899, unlimited: 997, bundle: 2150, micro: 749, },
    };
  // {
  //   AU: { country: "AU", micro: 149, mid: 179, unlimited: 249 },
  //   DE: { country: "DE", micro: 119, mid: 149, unlimited: 199 },
  //   NZ: { country: "NZ", micro: 149, mid: 179, unlimited: 249 },
  //   GB: { country: "GB", micro: 119, mid: 149, unlimited: 199 },
  //   CA: { country: "CA", micro: 119, mid: 149, unlimited: 199 },
  //   US: { country: "US", micro: 119, mid: 149, unlimited: 199 },
  //   DK: { country: "DK", micro: 749, mid: 899, unlimited: 1199 },  

  // };
  pricingTextLight: string;
  website: Website;
  settings: Settings;



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _authService: AuthService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _websiteStateStore: WebsiteStateStore,
    private _settingsStateStore: SettingsStateStore
  ) {

    document.title = 'Publish | Hitchd';
    this.route.queryParams
      .subscribe(params => {

        if (params['expired'] === 'true') {
          this.expired = true;

        } else {
          this.expired = false;
        }

        if (params['stripe'] === 'true') {
          this.stripe = true;

        } else {
          this.stripe = false;
        }
      });


    this.route.data.subscribe(data => {
      this.mode = data.mode;



    });

    this._authService.user.subscribe(user => {
      if (!user) {
        return;
      } else {
        this.user = user;
      }
    });



  }
  processing = false;

  checkIfGiftsUseLoops() {
    this.hasLoops = false;
    if (this.gifts && this.gifts.filter(x => x.videoUrl) && this.gifts.filter(x => x.videoUrl).length >= 1) {
      this.hasLoops = true;
    }
  }

  ngOnInit() {

    this.registry = this.route.snapshot.data.registry;
    this.gifts = this.route.snapshot.data.gifts;
    this.settings = this.route.snapshot.data.settings;
    this.website = this.route.snapshot.data.website;
;

    this._settingsStateStore.getState().subscribe(state => {
      if (state && state.settings) {
        this.settings = state.settings;
      }
    });


    this._websiteStateStore.getState().subscribe(state => {
      if (state && state.website) {
        
        this.website = state.website;
      }
    })


    this.checkIfGiftsUseLoops();
    this._registryFirebaseService
      .getGiftsforRegistry(this.registry.id)
      .subscribe(gifts => {

        if (gifts) {
          this.gifts = gifts;
          this.checkIfGiftsUseLoops();
        }
      });
    if (this.registry && this.registry.paid && this.registry.tier === 'full' && this.website && this.website.paid) {
      this.router.navigateByUrl('/overview');
    }

    this.checkTrailDays();

    this.uuid = localStorage.getItem('rollout-uid');
    if (!this.uuid) {
      this.uuid = this.uuidv4();
      localStorage.setItem('rollout-uid', this.uuid);
    }
    window.scrollTo(0, 0); // Scroll to top when component is loaded

    const ipCountry = this.country = this.registry.country;

    if (ipCountry) {
      this.country = ipCountry;
      this.setPricingFaq();
      this.setPricingFaqLight();
    } else {
      this.country = this.registry.country;
    }

    if (this.country == 'MX') {
      this.country = "US";
      this.currency = "USD";
      this.symbol = "$"
    }
    this.isEu = this.isCountryEu(this.country);



    this.currentPrice = this.pricing[this.country];
    if (!this.currentPrice && this.isEu) {
      this.currentPrice = this.pricing['DE'];
    } else if (!this.currentPrice && !this.isEu) {
      this.currentPrice = this.pricing['US'];
    }


    // if (this.registry.tier && (this.registry.tier === 'small' || this.registry.tier === 'medium')) {


    //   if (this.registry.tier === 'small') {
    //     this.currentPrice.mid = this.currentPrice.mid - this.currentPrice.micro;
    //     this.currentPrice.unlimited = this.currentPrice.unlimited - this.currentPrice.micro;
    //   }
    //   if (this.registry.tier === 'medium') {

    //     this.currentPrice.unlimited = this.currentPrice.unlimited - this.currentPrice.mid;
    //   }

    // }



    this.currency = this.getCurrency(this.country);
    this.symbol = this.getSymbol(this.country);

    this.determinePricingBoxesToDisplay();


  }
  setTestData(mode: string) {
    this.registry.tier = null;
    this.registry.paid = false;
    this.website.paid = false;
    this.settings.registryEnabled = false;
    this.paidAmount = 0;
    this.settings.weddingWebsiteEnabled = false;
    if (mode == 'regOnly') {

      this.registry.paid = false;
      this.settings.registryEnabled = true;
      this.settings.weddingWebsiteEnabled = false;
      this.website.paid = false;

    } else if (mode == 'webOnly') {
      this.registry.paid = false;
      this.settings.registryEnabled = false;
      this.settings.weddingWebsiteEnabled = true;
      this.website.paid = false;

    }
    else if (mode == 'both') {
      this.registry.paid = false;
      this.settings.registryEnabled = true;
      this.settings.weddingWebsiteEnabled = true;
      this.website.paid = false;

    }
    else if (mode == 'upgradeRegPlus') {
      this.registry.paid = true;
      this.registry.tier = 'medium'

      this.settings.registryEnabled = true;
      this.settings.weddingWebsiteEnabled = false;
      this.website.paid = false;

    }
    else if (mode == 'upgradeRegMirco') {
      this.registry.paid = true;
      this.registry.tier = 'small';
      this.settings.registryEnabled = true;
      this.settings.weddingWebsiteEnabled = false;
      this.website.paid = false;

    }

    
    else if (mode == 'upgradeRegUnlimited') {
      this.registry.paid = true;
      this.registry.tier = 'full'
      this.settings.registryEnabled = true;
      this.settings.weddingWebsiteEnabled = false;
      this.website.paid = false;

    }
    else if (mode == 'upgradeWeb') {
      this.registry.paid = false;
      this.settings.registryEnabled = false;
      this.settings.weddingWebsiteEnabled = true;
      this.website.paid = true;

    }

    this.determinePricingBoxesToDisplay();

  }

  determinePricingBoxesToDisplay() {
   ;
    if (!this.registry.paid && this.settings.registryEnabled && !this.settings.weddingWebsiteEnabled) {
      //reg only
      this.mode = 'pay';
      this.displayToggles = {
        registry: {
          plus: true,
          unlimited: true
        },
        website: false,
        bundle: true,
        current: ""

      }
    } else if (!this.website.paid && !this.settings.registryEnabled && this.settings.weddingWebsiteEnabled) {
      //web Only
      this.mode = 'pay';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: false
        },
        website: true,
        bundle: true,
        current: ""
      }
    } else if (!this.registry.paid && !this.website.paid && this.settings.registryEnabled && this.settings.weddingWebsiteEnabled) {
      //both
      this.mode = 'pay';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: true
        },
        website: true,
        bundle: true,
        current: ""
      }

    } else if (this.registry.paid && !this.website.paid && this.settings.registryEnabled && !this.settings.weddingWebsiteEnabled) {
      this.mode = 'upgrade';


      if (this.registry.tier == 'medium') {
        this.paidAmount = this.currentPrice.mid;
      } else if (this.registry.tier == 'small') {
        this.paidAmount = this.currentPrice.micro;
      } 
      else if (this.registry.tier == 'full') {
        this.paidAmount = this.currentPrice.unlimited;
      }

      //upgrade reg
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: this.registry.tier != 'full'
        },
        website: false,
        bundle: true,
        current: "registry"
      }
    } else if (this.website && this.website.paid && !this.registry.paid) {
      //upgrade web

      this.paidAmount = this.currentPrice.website;

      this.mode = 'upgrade';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: false
        },
        website: false,
        bundle: true,
        current: "website"
      }

    }
    else if ((this.website && !this.website.paid || !this.website) && this.registry.paid) {
      //upgrade web

      if (this.registry.tier == 'medium') {
        this.paidAmount = this.currentPrice.mid;
      } else if (this.registry.tier == 'small') {
        this.paidAmount = this.currentPrice.micro;
      } 
      else if (this.registry.tier == 'full') {
        this.paidAmount = this.currentPrice.unlimited;
      }
      


      this.mode = 'upgrade';
      this.displayToggles = {
        registry: {
          plus: false,
          unlimited: this.registry.tier != 'full',
        },
        website: false,
        bundle: true,
        current: "registry"
      }

    }



  }

  checkTrailDays() {
    if (this.registry && this.registry.paid !== undefined && this.registry.paid === false) {

      this.daysLeft = this._registryFirebaseService.trialLeft(this.registry);

    }
  }



  getCurrency(countryCode) {
    if (countryCode === 'AU') {
      return 'AUD';
    } else if (countryCode === 'CA') {
      return 'CAD';
    } else if (countryCode === 'US') {
      return 'USD';
    } else if (countryCode === 'NZ') {
      return 'NZD';
    } else if (countryCode === 'GB') {
      return 'GBP';

    }
    // else if (countryCode === 'MX') {
    //   return 'MXN';
    // } 

    else if (countryCode === 'DK') {
      return 'DKK';


    } else if (this.isEu) {
      return 'EUR';
    } else {
      return 'USD';
    }
  }

  isCountryEu(country) {
    return this.euCountries.includes(country);
  }

  getSymbol(countryCode) {
    if (countryCode === 'AU') {
      return '$';
    } else if (countryCode === 'CA') {
      return '$';
    } else if (countryCode === 'US') {
      return '$';
    } else if (countryCode === 'NZ') {
      return '$';
    } else if (countryCode === 'GB') {
      return '£';
    } else if (countryCode === 'DK') {
      return 'Kr ';
    } else if (this.isEu) {
      return '€ ';
    } else {
      return '$';
    }
  }


  setPricingFaq() {
    this.pricingText = '';
    switch (this.country) {
      case 'AU': {
        this.pricingText =
          '1.7% + $0.30 for local Australian credit cards / +1.7% for international cards';
        break;
      }
      case 'MX': {
        this.pricingText =
          '3.6% + MXN$3 + IVA';
        break;
      }
      case 'DK': {
        this.pricingText =
          '1.4% + Kr 1.8 for all European credit cards / +1.5% for non-EU credit cards';
        break;
      }
      case 'US': {
        this.pricingText = '2.9% +$0.30 for US credit cards';
        break;
      }
      case 'CA': {
        this.pricingText =
          '2.9% + $0.30 for Canadian credit cards / +0.6% for international cards';
        break;
      }
      case 'NZ': {
        this.pricingText = '2.9% + $0.30';
        break;
      }
      case 'HK': {
        this.pricingText = '3.4% + $2.35';
        break;
      }
      case 'GB': {
        this.pricingText =
          '1.4% + £0.20 for UK and European credit cards and +1.5% for non-EU cards';
        break;
      }
      case 'JP': {
        this.pricingText = '3.6%';
        break;
      }
      case 'US': {
        this.pricingTextLight = '2.9% + $0.30 (+1% for Int. cards)';
        break;
      }
      case 'SG': {
        this.pricingText = '3.4% + $0.50';
        break;
      }
      default: {
        this.pricingText =
          '1.4% + €0.25 for European and UK credit cards and +1.5% for non-EU cards';
        break;
      }
    }
  }

  setPricingFaqLight() {
    this.pricingTextLight = '';
    switch (this.country) {
      case 'AU': {
        this.pricingTextLight =
          '1.7% + $0.30 (+1.7% for Int. cards)';
        break;
      }
      case 'MX': {
        this.pricingTextLight =
          '3.6% + MSN$ 3';
        break;
      }
      case 'DK': {
        this.pricingTextLight =
          '1.4% + Kr 1.8 (+1.5% for non-EU cards)';
        break;
      }
      case 'US': {
        this.pricingTextLight = '2.9% + $0.30 (+1% for Int. cards)';
        break;
      }
      case 'CA': {
        this.pricingTextLight =
          '2.9% + $0.30 (+0.6% for Int. cards)';
        break;
      }
      case 'NZ': {
        this.pricingTextLight = '2.9% + $0.30';
        break;
      }
      case 'HK': {
        this.pricingTextLight = '3.4% + $2.35';
        break;
      }
      case 'GB': {
        this.pricingTextLight =
          '1.4% + £0.20 for UK/EU cards (+1.5% for Int. cards)';
        break;
      }
      case 'JP': {
        this.pricingTextLight = '3.6%';
        break;
      }
      case 'SG': {
        this.pricingTextLight = '3.4% + $0.50';
        break;
      }
      default: {
        this.pricingTextLight =
          '1.4% + €0.25 for EU/UK cards (+1.5% for non-EU cards)';
        break;
      }
    }
  }

  uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  goBack(){
    window.history.back();
  }

  upgradeAccount(type: string) {
    (window as any).stripe = Stripe(environment.stripePublicKey, {

    });

    this.type = type;
    this.processing = true;
    return fetch(environment.firebase.clouldFunctionHost + '/createCheckoutSession', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        userAgent: navigator.userAgent,
        url: location.href,
        locale: 'auto',
        registryId: this.registry.id,
        source: this.registry.source,
        campaign: this.registry.campaign,
        partnershipId: this.registry.partnershipId,
        userId: this.registry.userId,
        uuid: this.uuid,
        country: this.country,
        isEu: this.isEu,
        email: this.user.email,
        type: this.type,
        fromStripe: this.stripe,
        hoursLeft: this.daysLeft,
        isUpgrade: this.mode === 'upgrade',
        referalUserId: this.mode != 'upgrade' && this.registry.referalUserId ? this.registry.referalUserId : null,
        fromTier: this.registry.tier ? this.registry.tier : null,

      }),
    }).then((result) => {

      const reulst = result.json();
      reulst.then((x: any) => {
        const sessionId = x.sessionId;

        (window as any).stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: sessionId
        }).then(function (redirectResult) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
        //  return redirectResult.json();
      });


    }
    );
    //

  }

}



// WEBPACK FOOTER //
// ./src/app/hitchd-payment-page/hitchd-payment-page.component.ts